import type { ExportTarget } from '../types.ts';

export const mapExportTargetsToRecord = (targets?: ExportTarget[]): Record<ExportTarget, boolean> => {
  const allExportTargets = ['cookie', 'device', 'idl', 'ctv', 'ip', 'id5'] as const satisfies ExportTarget[];
  const targetSet = new Set(targets);

  return allExportTargets.reduce(
    (acc, key) => {
      acc[key] = targetSet.has(key);

      return acc;
    },
    {} as Record<ExportTarget, boolean>
  );
};
